import { StockInputValue_Edit_Option } from '@services/MarppleShopStudio/widget/CreatorProduct/ui/ProductForm/input-views/Input_Stock/types.ts';
import { StockType } from '@services/MarppleShopStudio/widget/CreatorProduct/core/zod-schema/constants.ts';
import { MODE } from '@services/MarppleShopStudio/widget/CreatorProduct/core/types/types.ts';
import { InputEditor } from '@services/MarppleShopStudio/widget/CreatorProduct/ui/ProductForm/input-views/type.ts';
import klass from './Input_Stock.module.scss';
import common_klass from '../../section-views/styles/common.module.scss';
import { Html, html } from 'rune-ts';
import {
  ALL_CHECK_NAME,
  Base_Input_Stock,
  CHECK_BOX_KLASS,
} from '@services/MarppleShopStudio/widget/CreatorProduct/ui/ProductForm/input-views/Input_Stock/Base_Input_Stock.ts';
import { stockDataUtil } from '@services/MarppleShopStudio/widget/CreatorProduct/ui/ProductForm/input-views/Input_Stock/util.ts';
import { ButtonCheckbox } from '@services/MarppleShop/renderApp/components/atoms/ButtonCheckbox/ButtonCheckbox.ts';
import { classes, doIf } from '@services/MarppleShop/shared/util';
import { shareFont } from '@services/MarppleShop/shared/typography';
import { Tooltip } from '@services/MarppleShop/renderApp/components/atoms/Tooltip/Tooltip.ts';
import { unEscaper } from '@shared/utils/escape.ts';

interface InputStock_Edit_Option extends InputEditor {
  mode: typeof MODE.EDIT | typeof MODE.EDIT_TPL;
  stock_type: typeof StockType.OPTION_STOCK;
  value: StockInputValue_Edit_Option[];
  readonly?: boolean;
  is_studio_worker_admin?: boolean;
}

export class Input_Stock_EditOption extends Base_Input_Stock<InputStock_Edit_Option> {
  protected override inputTemplate() {
    return html`
      <div
        class="${classes(klass.stock_table, {
          [klass.edit_option_sku]: this.data.readonly,
          [klass.edit_option_tpl]: this.data.mode !== MODE.EDIT && !this.data.readonly,
          [klass.edit_option]: this.data.mode === MODE.EDIT,
        })}"
      >
        <div class="${klass.row} ${klass.header}">
          ${doIf(
            () =>
              new ButtonCheckbox({
                name: ALL_CHECK_NAME,
                active: false,
                klass: CHECK_BOX_KLASS,
              }),
            !this.data.readonly,
          )}
          <div class="${klass.col}">품목</div>
          <div class="${klass.col}">추가 금액</div>
          <div class="${klass.col}">재고</div>
          ${doIf(
            () => html`
              <div class="${klass.col}">
                재고 관리 번호
                ${new Tooltip({
                  id: this.data.name,
                  content: html`
                    <div class="${common_klass.tooltip_content_container} ${shareFont('14_medium')}">
                      <div class="${common_klass.tooltip_content_divider}">
                        <span>·</span>
                        <span>재고관리번호를 입력하지 않은 경우 자동생성됩니다.</span>
                      </div>
                      <div class="${common_klass.tooltip_content_divider}">
                        <span>·</span>
                        <span
                          >입고 상품을 등록한 후엔 옵션, 재고관리번호, 상품 카테고리는 수정할 수
                          없습니다.</span
                        >
                      </div>
                    </div>
                  `,
                  size: 'x_small',
                  variant: 'studio',
                })}
              </div>
            `,
            this.data.mode !== MODE.EDIT,
          )}
        </div>
        ${this.data.value.map((item, index) => {
          return html`
            <div class="${klass.row}">
              ${doIf(
                () =>
                  html`<div class="${klass.col}">
                    ${new ButtonCheckbox({
                      name: `checkbox__${index}`,
                      active: false,
                      klass: CHECK_BOX_KLASS,
                      index,
                    })}
                  </div>`,
                !this.data.readonly,
              )}
              <div class="${klass.col} ${klass.wide}">${unEscaper(item.name)}</div>
              <div class="${klass.col}">
                ${stockDataUtil.numberInput({
                  index,
                  name: this.data.name,
                  value: item.price,
                  readonly:
                    this.data.readonly ||
                    (this.data.mode === MODE.EDIT_TPL && !this.data.is_studio_worker_admin),
                  onFocusout: (view) => {
                    this.onNumericOptionChange(view, 'price');
                  },
                })}
              </div>
              <div class="${klass.col}">
                ${stockDataUtil.numberInput({
                  index,
                  name: this.data.name,
                  value: item.stock,
                  readonly: this.data.mode === MODE.EDIT_TPL && !this.data.is_studio_worker_admin,
                  onFocusout: (view) => {
                    this.onNumericOptionChange(view, 'stock');
                  },
                })}
              </div>
              ${doIf(
                () => html`
                  <div class="${klass.col}">
                    ${stockDataUtil.textInput({
                      index,
                      name: this.data.name,
                      value: item.sku || String(item.id || ''),
                      placeholder: 'SKU',
                      readonly: this.data.readonly,
                      onFocusout: (view) => {
                        this.onStringOptionChange(view, 'sku');
                      },
                    })}
                  </div>
                `,
                this.data.mode !== MODE.EDIT,
              )}
            </div>
          `;
        })}
      </div>
    `;
  }

  override titleRightHtml(): Html {
    return html`<div class="${klass.button_wrap} ${klass.hidden}">${this.deleteButton}</div>`;
  }
}
